###
We have 2 login options:
- Regular login flow (/login page)
- Modal iframe login (it opens a modal with an iframe pointing to /login/iframe)

The login iframe is loaded after everything else has been loaded.

If the user clicks on something that requires authentication before the iframe has been loaded,
then they will be redirected to the regular login flow. This is to prevent a problem with the iframe
interfering with the login flow.
###

_iframeLoaded = false

MPP.JsonResponseHandler = class

  @getCurrentUrl: ->
    "#{window.location.protocol}//#{window.location.host}#{window.location.pathname}"

  @redirectToLogin: ->
    # Touch login uses the return_to query parameter.
    # Desktop login uses the ref query parameter.
    OptimizeSuite.TrackingHub.add 'MerchantPage-Login-Redirect'

    currentUrl = encodeURIComponent @getCurrentUrl()
    loginLink = "/login?ref=#{currentUrl}&return_to=#{currentUrl}"
    window.location.href = loginLink

  @openModalIframeLogin: ->
    OptimizeSuite.TrackingHub.add 'MerchantPage-Login-Modal'

    if not @iframeLoginInitialized
      IframeLogin.init
        iframeLogin:
          # We will open the modal manually after getting an error response from the server, not with "data-login-required",
          # so it's safe to set this to false all the time.
          authenticated: false
          authType: 'login'
          src: '/login/iframe'
      @iframeLoginInitialized = true

    IframeLogin.openModal @getCurrentUrl()

  @loginRequired: (res, options = {}) ->
    return false unless res?.error?.code is 'login-required'

    if options.method is 'redirect' or not $('#login-modal').length
      @redirectToLogin()
    else if _iframeLoaded is true
      @openModalIframeLogin()
    else
      # If the iframe has not been loaded yet, we set an interval to check when it's ready.
      # This weird logic is necessary because of how the groupon-iframe-login module works:
      # it will automatically reload the page if the user tries to open the modal before the iframe has been loaded.

      start = new Date().getTime()

      waitForIframeToLoad = =>
        now = new Date().getTime()
        if not _iframeLoaded and (now - start > 2500)
          # redirect to login if iframe fails to load in 2.5 seconds
          clearInterval interval
          @redirectToLogin()
          return

        return unless _iframeLoaded is true
        clearInterval interval
        @openModalIframeLogin()

      interval = setInterval waitForIframeToLoad, 250

    true

$(window).load ->
  # delay the iframe loading until after everything else has been loaded
  $iframe = $ '#login-modal iframe'
  return unless $iframe.length
  $iframe.attr 'src', '/login/iframe'
  $iframe.attr 'height', '503'
  $iframe.load -> _iframeLoaded = true
